import { useEffect } from 'react';

// A sheet that owns the keyboard while open. The Rhythm and Instrument sheets carry the same player's
// Play, so Space still plays and stops over them.
export const KEYBOARD_SHEET = '.BottomSheet:not(.RhythmSheet):not(.InstrumentSheet)';

/**
 * Space plays and stops a preview dialog's player, as it does in the builder. On the document,
 * because focus is wherever the last tap left it — and preventDefault stops that button clicking.
 *
 * @param {object} player - From useChordBarsPreview or useMidiPreview
 * @param {boolean} isActive - The dialog is open
 */
const useSpacePlay = (player, isActive) => {
  const { isPlaying, canPlay, play, stop } = player;

  useEffect(() => {
    if (!isActive) return undefined;

    const handleKeyDown = (event) => {
      if (event.key !== ' ' || event.repeat || event.metaKey || event.ctrlKey || event.altKey) return;

      const { tagName, isContentEditable } = event.target;

      // A field keeps its space; the transport's toggles and the volume sheet's controls are pressed with it
      if (isContentEditable || tagName === 'INPUT' || tagName === 'TEXTAREA' || tagName === 'SELECT') return;
      if (event.target.closest?.('.ChordBarsTransport, .HeaderSheet')) return;
      // An open menu or sheet owns the keyboard until it closes
      if (document.querySelector(`.mg-dropdown__menu, ${KEYBOARD_SHEET}`)) return;

      event.preventDefault();

      if (isPlaying) stop();
      else if (canPlay) play();
    };

    document.addEventListener('keydown', handleKeyDown);

    return () => document.removeEventListener('keydown', handleKeyDown);
  }, [isActive, isPlaying, canPlay, play, stop]);
};

export default useSpacePlay;
